export const isDateValid = (date: {
  year: number | null;
  month: number | null;
  day: number | null;
}) => {
  if (date?.year && date?.month && date?.day) {
    const maxDay = new Date(date.year, date.month, 0).getDate();
    return date.day >= 1 && date.day <= maxDay;
  }
  return true;
};

export const compareDates = (start: any, end: any): boolean => {
  const hasStartYear = start?.year != null;
  const hasEndYear = end?.year != null;
  if (!hasStartYear || !hasEndYear) return true;

  if (start.year < end.year) return true;
  if (start.year > end.year) return false;
  const hasStartMonth = start?.month != null;
  const hasEndMonth = end?.month != null;

  if (!hasStartMonth || !hasEndMonth) return true;

  if (start.month < end.month) return true;
  if (start.month > end.month) return false;
  const hasStartDay = start?.day != null;
  const hasEndDay = end?.day != null;

  if (!hasStartDay || !hasEndDay) return true;

  return start.day <= end.day;
};

export const isEducationChanged = (current: any, original: any) => {
  const fields = [
    "institution",
    "location",
    "degree",
    "field_of_study",
    "start_date",
    "end_date",
    "is_current",
  ];
  return fields.some((field) => {
    if (["start_date", "end_date"].includes(field)) {
      return (
        current[field]?.year !== original[field]?.year ||
        current[field]?.month !== original[field]?.month ||
        current[field]?.day !== original[field]?.day
      );
    }
    return current[field] !== original[field];
  });
};

export const getYears = () =>
  Array.from({ length: 100 }, (_, i) => {
    const year = new Date().getFullYear() - i;
    return { value: year.toString(), label: year.toString() };
  });

export const getMonths = () =>
  Array.from({ length: 12 }, (_, i) => {
    const value = (i + 1).toString();
    return { value, label: value.padStart(2, "0") };
  });

export const getDaysInMonth = (month: number, year: number) => {
  if (!month || !year) return [];
  const days = new Date(year, month, 0).getDate();
  return Array.from({ length: days }, (_, i) => ({
    value: (i + 1).toString(),
    label: (i + 1).toString().padStart(2, "0"),
  }));
};
